import axios from 'axios';
import JSZip from 'jszip';
import { arrayOf, node, number, string } from 'prop-types';
import React from 'react';

import FileDownloader from '../../generic/FileDownloader';
import api from '../../REST/api';

function CreativesMultiDownload({ creatives, fileName, children, ...rest }) {
  const downloadAndZipFiles = async () => {
    // Loading new creatives from the BE refreshes the image signature
    // and thus busts the browser cache.
    // This is to fix https://github.bus.zalan.do/zms-automation/sales-cockpit-fe/issues/1621
    const newlyLoadedCreatives = await Promise.all(
      creatives.map(id => api.getCreative({ id })),
    );
    const blobs = await Promise.all(
      newlyLoadedCreatives.map(({ fileUrl }) =>
        axios.get(fileUrl, { responseType: 'blob' }),
      ),
    );
    const zip = new JSZip();
    const imagesFolder = zip.folder(fileName);

    blobs.forEach((blob, index) => {
      imagesFolder.file(newlyLoadedCreatives[index].name, blob.data);
    });

    const zipFile = await zip.generateAsync({ type: 'blob' });
    return { data: zipFile, name: `${fileName}.zip` };
  };
  return (
    <FileDownloader
      disabled={!creatives.length}
      onGetFile={downloadAndZipFiles}
      {...rest}
    >
      {children}
    </FileDownloader>
  );
}

CreativesMultiDownload.propTypes = {
  creatives: arrayOf(number.isRequired).isRequired,
  fileName: string.isRequired,
  children: node.isRequired,
};
export default CreativesMultiDownload;
